import { observer } from 'mobx-react';
import React from 'react';

import { DetailsLoaderProps } from './types';

@observer
export default class DetailsLoader<Params extends Record<string, string | undefined>> extends React.Component<
  DetailsLoaderProps<Params>
> {
  componentDidMount(): void {
    this.loadDetails();
  }

  componentDidUpdate(prevProps: DetailsLoaderProps<Params>): void {
    const { store, routeParam, params } = this.props;
    const { params: prevParams } = prevProps;

    if (params[routeParam] !== prevParams[routeParam]) {
      store.reset();
      store.loadDetails(params[routeParam] as string);
    }
  }

  componentWillUnmount(): void {
    const { store } = this.props;

    const { avoidReset } = this.props;

    if (!avoidReset) {
      store.reset();
    }
  }

  loadDetails = (): void => {
    const { store, routeParam, params } = this.props;

    store.loadDetails(params[routeParam] as string);
  };

  render(): React.ReactNode {
    const {
      store: { isLoaded, error },
      children,
    } = this.props;

    return children({
      isLoaded,
      error,
      reload: this.loadDetails,
    });
  }
}
